import styled from "styled-components";

const ExperienceCard = styled.div`
  display: flex;
  margin-top: 25px;
  gap: 20px;

  /* =============================
     COMPANY LIST (LEFT)
  ============================== */
  & .experience-card__companies {
    display: flex;
    flex-direction: column;
    min-width: 160px;
  }

  /* =============================
     BUTTONS
  ============================== */
  & button {
    appearance: none;
    background-color: transparent;
    border: none;
    border-right: 2px solid #cdb8b88c;
    padding: 10px 24px;
    width: 160px;
    text-align: left;
    color: #ffffffb5;
    cursor: pointer;
    transition: all 0.25s ease;
    font-size: 0.9rem;
  }

  & button:hover {
    background-color: rgba(100, 255, 218, 0.05);
    color: #64ffda;
  }

  /* =============================
     ACTIVE STATE
  ============================== */
  & .activeExperience {
    color: #64ffda;
    border-right-color: #64ffda;
    background-color: #122645;
  }

  /* =============================
     LARGE SCREENS (≥ 1440px)
  ============================== */
  @media (min-width: 1440px) {
    & button {
      font-size: 1rem;
      padding: 12px 28px;
    }
  }

  /* =============================
     TABLETS (≤ 1024px)
  ============================== */
  @media (max-width: 1024px) {
    gap: 16px;

    & button {
      width: 150px;
      padding: 10px 20px;
    }
  }

  /* =============================
     MOBILE / SMALL TABLET (≤ 768px)
  ============================== */
  @media (max-width: 768px) {
    flex-direction: column;

    & .experience-card__companies {
      flex-direction: row;
      overflow-x: auto;
      width: 100%;
    }

    & button {
      width: auto;
      min-width: 140px;
      border-right: none;
      border-bottom: 2px solid #cdb8b88c;
      text-align: center;
      white-space: nowrap;
    }

    & .activeExperience {
      border-bottom-color: #64ffda;
    }
  }

  /* =============================
     SMALL MOBILE (≤ 480px)
  ============================== */
  @media (max-width: 480px) {
    margin-top: 16px;

    & button {
      font-size: 0.8rem;
      padding: 8px 16px;
      min-width: 120px;
    }
  }
`;

export default ExperienceCard;
